import { render } from "./hero-image.vue?vue&type=template&id=109bb8b9&ts=true"
import script from "./hero-image.vue?vue&type=script&lang=ts"
export * from "./hero-image.vue?vue&type=script&lang=ts"

import exportComponent from "/geosite/web/geosite-de/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__